import { useContext } from "react";
import { AuthContext } from "@ctx/AuthContexts";
import type { AuthContextType } from "@ctx/AuthContext";

export const useAuthContext = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthContext must be used within AuthProvider");
  return ctx;
};
